export default {
  onlineHome: {
    path: '/online/home',
    name: 'onlineHome',
    component: () => import('./home.vue')
  },
  newDetail: {
    path: '/online/new-detail',
    name: 'newDetail',
    component: () => import('./newDetail.vue')
  },
  fileDetail: {
    path: '/online/file-detail',
    name: 'fileDetail',
    component: () => import('./fileDetail.vue')
  }
}